import { inject } from 'vue'
import { Config } from './types/Config'

export function getConfig (): Config {
  const config = inject<Config>('vue-service:config')

  if (!config) {
    throw new Error('could not find the config. Ensure it is created when the app is bootstrapped')
  }

  return config
}
